common.View.create('galaxy::habitats.website.partials.search.Index', {

    lastSearchRequest: null,

    /**
     * Called when DOM is ready.
     */
    onDOMLoad() {
        this.initSearch();
        //this.initHashChange();
        this.initCloseForm();

        // Refresh pagination triggers
        this.initPagination();
    },

    show()
    {
        this.element

            // Show
            .toggleClass('tw-hidden')

            // Focus on input.
            .find('input[name="query"]')
            .focus()
            .end();

        // Toggle overflow (background scrolling)
        $(document.body).toggleClass('tw-overflow-hidden');

        //
        this.getSearchData();
    },

    initSearch()
    {
        let typeTimer,
            doneTypingInterval = 200;

        this.element
            .find('input, select')
                .on('change keyup', (event) => {
                    // Clear time out (since user is still typing)
                    clearTimeout(typeTimer);

                    // After done typing
                    typeTimer = setTimeout(() => {
                        // Search data
                        this.getSearchData();
                    }, doneTypingInterval);
                })
                .end()

            .find('[type="submit"]')
                .on('click', (event) => {
                    // Trigger search
                    this.element.find('input, select').trigger('change');

                     // Stop normal behavior
                    return false;
                })
                .end();
    },

    getSearchData(page = 1)
    {
        // Get all inputs
        let postData = this.element.find('form').serialize();

        // Stop current request?
        if(this.lastSearchRequest)
            this.lastSearchRequest.abort();

        // Ajax search
        this.lastSearchRequest = $.post('/search?page=' + page, postData).done((viewData) => {
            this.lastSearchRequest = null;

            this.element.find('.result').html( viewData );

            //location.hash = page;
        });
    },

    initPagination()
    {
        $(document).on('click', '.galaxy\\:\\:habitats-website-partials-search-Index .pagination a', (event) => {
            // Remove active from pagination
            this.element.find('.pagination li').removeClass('active');

            // Set current pagination item as active
            $(event.currentTarget).parent('li').addClass('active');

            // Get page
            let page = $(event.currentTarget).attr('href').split('page=')[1];

            // Search data
            this.getSearchData(page);

            //
            return false;
        })
        .end();
    },

    initCloseForm() {
        this.element.on('click keyup', (e) => {
            // Click is outside of search form?
            let container = this.element.find('.content');

            // Check if clicked outside the container or escape is pressed
            if (container.has(e.target).length === 0 || e.key === 'Escape') {
                this.element.addClass('tw-hidden');
            }

            // Toggle overflow (background scrolling)
            $(document.body).removeClass('tw-overflow-hidden');
        });
    }

});